import { FC } from 'react'
import Link from 'next/link'
import HomeSvg from '@/public/images/common/home_v2.svg'
import { useRouter } from 'next/router'
import styles from './index.module.scss'

type Props = {
  items: {
    label: string
  }[]
}

export const Breadcrumb: FC<Props> = ({ items }) => {
  const router = useRouter()
  // `/` と `?` で分割。空文字は除外
  const pathSegments = router.asPath.split(/[/?]/).filter(Boolean)
  return (
    <div className='container'>
      <nav>
        <ol className={styles.breadcrumb}>
          <li>
            <Link href='/'>
              <div className={styles.home}>
                <HomeSvg viewBox='0 0 24 24' />
              </div>
            </Link>
          </li>
          {items?.map((item, index) => (
            <li key={item.label}>
              {index !== items.length - 1 ? (
                <Link href={`/${pathSegments.slice(0, index + 1).join('/')}`}>
                  <a className={styles.inActive}>{item.label}</a>
                </Link>
              ) : (
                <span className={styles.active}>{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  )
}
